export const PAYMENT_CREDIT = true;
export const PAYMENT_DEBIT = false;
// export const PAYMENT_STATUS_ALL = 'all';
export const PAYMENT_STATUS_WAITING = "waiting";
export const PAYMENT_STATUS_PROCESSING = "processing";
export const PAYMENT_STATUS_APPROVED = "approved";
export const PAYMENT_STATUS_CANCELLED = "cancelled";
export const PAYMENT_STATUS_COMPLETED = "completed";
export const PAYMENT_STATUS_REFUNDED = "refunded";
export const PAYMENT_STATUS_ANTICIPATION = "anticipated";

export const PAYMENT_MOST_RECENT_ORDER = "created_at_desc";
export const PAYMENT_LOWER_ORDER = "created_at_asc";
export const PAYMENT_HIGHEST_VALUE_ORDER = "amount_desc";
export const PAYMENT_LOWER_VALUE_ORDER = "amount_asc";

export const CARD_BRAND_VISA = "visa";
export const CARD_BRAND_VISA_ELECTRON = "visa electron";
export const CARD_BRAND_MASTERCARD = "mastercard";
export const CARD_BRAND_HIPERCARD = "hipercard";
export const CARD_BRAND_ELO = "elo";
export const CARD_BRAND_ELO_DEBIT = "elo debito";
export const CARD_BRAND_MAESTRO = "maestro";
export const CARD_BRAND_AMEX = "amex";

export const DEPOSIT_STATUS_SCHEDULED = "scheduled";
export const DEPOSIT_STATUS_PROCESSING = "processing";
export const DEPOSIT_STATUS_CANCELLED = "cancelled";
export const DEPOSIT_STATUS_COMPLETED = "completed";
export const DEPOSIT_STATUS_FAILED = "failed";
export const DEPOSIT_STATUS_DOWNED = "downed";
export const DEPOSIT_STATUS_ANTECIPATED = "anticipated";

export const DEPOSIT_MOST_RECENT_ORDER = "created_at_desc";
export const DEPOSIT_LOWER_ORDER = "created_at_asc";
export const DEPOSIT_HIGHEST_VALUE_ORDER = "amount_desc";
export const DEPOSIT_LOWER_VALUE_ORDER = "amount_asc";

export const WALLET_MOST_RECENT_ORDER = "created_at_desc";
export const WALLET_LOWER_ORDER = "created_at_asc";
export const WALLET_HIGHEST_VALUE_ORDER = "amount_desc";
export const WALLET_LOWER_VALUE_ORDER = "amount_asc";

export const OPERATION_DEBIT = false;
export const OPERATION_CREDIT = true;

export const PARTNER_ACCOUNT_PERSONAL = "personal";
export const PARTNER_ACCOUNT_BUSINESS = "business";

export const PARTNER_FRANCHISOR = "franchisor";
export const PARTNER_MASTER = "master";
export const PARTNER_EXECUTIVE = "executive";
export const PARTNER_ESTABLISHMENT = "establishment";

export const PARTNER_MOST_RECENT_ORDER = "created_at_desc";
export const PARTNER_LOWER_ORDER = "created_at_asc";
export const ORDINATION = "created_at_desc";

export const DIGITAL_SYSTEM_INCREMMENT = "digital_system_incremment";
export const DIGITAL_SYSTEM_DECREMMENT = "digital_system_decremment";
export const DIGITAL_BILL_DEPOSIT = "digital_bill_deposit";
export const REFOUND = "refound";
export const DIGITAL_LIQUIDATION = "digital_liquidation";
export const DIGITAL_PAYMENT = "digital_payment";
export const DIGITAL_RECHARGE = "digital_recharge";
export const DIGITAL_WITHDRAW = "digital_withdraw";
export const DIGITAL_TRANSFER_SENDED = "digital_transfer_sended";
export const DIGITAL_TRANSFER_RECEIVED = "digital_transfer_received";
export const DIGITAL_SWIPE_TRANSFER_INCREMMENT = "digital_swipe_transfer_incremment";
export const DIGITAL_SWIPE_TRANSFER_DECREMMENT = "digital_swipe_transfer_decremment";
